// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/vision_shotlist_config.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/vision_shotlist_config.proto.
 */
export const file_vision_shotlist_v1_vision_shotlist_config: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vc2hvdGxpc3QvdjEvdmlzaW9uX3Nob3RsaXN0X2NvbmZpZy5wcm90bxIZcHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MSKnAQoUVmlzaW9uU2hvdGxpc3RDb25maWcSSAoPdmlzaWJsZV9jb2x1bW5zGAEgAygOMi8ucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90bGlzdENvbHVtbhJFCgxjb2x1bW5fb3JkZXIYAiADKA4yLy5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvblNob3RsaXN0Q29sdW1uKsAFChRWaXNpb25TaG90bGlzdENvbHVtbhIiCh5WSVNJT05fU0hPVExJU1RfQ09MVU1OX1VOS05PV04QABImCiJWSVNJT05fU0hPVExJU1RfQ09MVU1OX1NIT1RfTlVNQkVSEAESJAogVklTSU9OX1NIT1RMSVNUX0NPTFVNTl9USFVNQk5BSUwQAhIgChxWSVNJT05fU0hPVExJU1RfQ09MVU1OX1NDRU5FEAMSIwofVklTSU9OX1NIT1RMSVNUX0NPTFVNTl9MT0NBVElPThAEEiYKIlZJU0lPTl9TSE9UTElTVF9DT0xVTU5fREVTQ1JJUFRJT04QBRIfChtWSVNJT05fU0hPVExJU1RfQ09MVU1OX0NBU1QQBhIlCiFWSVNJT05fU0hPVExJU1RfQ09MVU1OX0ZSQU1FX1NJWkUQBxIgChxWSVNJT05fU0hPVExJU1RfQ09MVU1OX0FOR0xFEAgSKgomVklTSU9OX1NIT1RMSVNUX0NPTFVNTl9DQU1FUkFfTU9WRU1FTlQQCRIkCiBWSVNJT05fU0hPVExJU1RfQ09MVU1OX0VRVUlQTUVOVBAKEiAKHFZJU0lPTl9TSE9UTElTVF9DT0xVTU5fUFJPUFMQCxIpCiVWSVNJT05fU0hPVExJU1RfQ09MVU1OX0RJUkVDVE9SX05PVEVTEAwSIwofVklTSU9OX1NIT1RMSVNUX0NPTFVNTl9EUF9OT1RFUxANEiQKIFZJU0lPTl9TSE9UTElTVF9DT0xVTU5fVkZYX05PVEVTEA4SJAogVklTSU9OX1NIT1RMSVNUX0NPTFVNTl9TRlhfTk9URVMQDxIjCh9WSVNJT05fU0hPVExJU1RfQ09MVU1OX0RJQUxPR1VFEBASKAokVklTSU9OX1NIT1RMSVNUX0NPTFVNTl9TSE9PVElOR19USU1FEBFiBnByb3RvMw");

/**
 * @generated from message protos.vision.shotlist.v1.VisionShotlistConfig
 */
export type VisionShotlistConfig = Message<"protos.vision.shotlist.v1.VisionShotlistConfig"> & {
  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShotlistColumn visible_columns = 1;
   */
  visibleColumns: VisionShotlistColumn[];

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShotlistColumn column_order = 2;
   */
  columnOrder: VisionShotlistColumn[];
};

/**
 * Describes the message protos.vision.shotlist.v1.VisionShotlistConfig.
 * Use `create(VisionShotlistConfigSchema)` to create a new message.
 */
export const VisionShotlistConfigSchema: GenMessage<VisionShotlistConfig> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_vision_shotlist_config, 0);

/**
 * @generated from enum protos.vision.shotlist.v1.VisionShotlistColumn
 */
export enum VisionShotlistColumn {
  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_SHOT_NUMBER = 1;
   */
  SHOT_NUMBER = 1,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_THUMBNAIL = 2;
   */
  THUMBNAIL = 2,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_SCENE = 3;
   */
  SCENE = 3,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_LOCATION = 4;
   */
  LOCATION = 4,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_DESCRIPTION = 5;
   */
  DESCRIPTION = 5,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_CAST = 6;
   */
  CAST = 6,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_FRAME_SIZE = 7;
   */
  FRAME_SIZE = 7,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_ANGLE = 8;
   */
  ANGLE = 8,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_CAMERA_MOVEMENT = 9;
   */
  CAMERA_MOVEMENT = 9,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_EQUIPMENT = 10;
   */
  EQUIPMENT = 10,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_PROPS = 11;
   */
  PROPS = 11,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_DIRECTOR_NOTES = 12;
   */
  DIRECTOR_NOTES = 12,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_DP_NOTES = 13;
   */
  DP_NOTES = 13,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_VFX_NOTES = 14;
   */
  VFX_NOTES = 14,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_SFX_NOTES = 15;
   */
  SFX_NOTES = 15,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_DIALOGUE = 16;
   */
  DIALOGUE = 16,

  /**
   * @generated from enum value: VISION_SHOTLIST_COLUMN_SHOOTING_TIME = 17;
   */
  SHOOTING_TIME = 17,
}

/**
 * Describes the enum protos.vision.shotlist.v1.VisionShotlistColumn.
 */
export const VisionShotlistColumnSchema: GenEnum<VisionShotlistColumn> = /*@__PURE__*/
  enumDesc(file_vision_shotlist_v1_vision_shotlist_config, 0);

